import { createAsyncThunk } from "@reduxjs/toolkit";
import asyncInstance from "config/AsyncInstance";
import apiInstance from "config/axiosInstance";

export const GetAllEmpolyee = createAsyncThunk(
  "empolyee/GetAllEmpolyee",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("profiles/employeeList", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const CreateEmpolyee = createAsyncThunk(
  "empolyee/CreateEmpolyee",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("profiles/employeeCreate", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const ImportEmpolyee = createAsyncThunk(
  "empolyee/ImportEmpolyee",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("profiles/employeeImport", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const EmpolyeeCheckValidation = createAsyncThunk(
  "empolyee/EmpolyeeCheckValidation",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("fieldCheck", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const ViewEmpolyee = createAsyncThunk(
  "empolyee/ViewEmpolyee",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(
        `profiles/employeeView/${body}`,
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const DeleteEmpolyee = createAsyncThunk(
  "empolyee/DeleteEmpolyee",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(
        `profiles/employeeDel/${body}`,
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
